// extracted by mini-css-extract-plugin
export default {"ActivateButton":"AttachedFilesTable_ActivateButton__zNtjK","DeleteButton":"AttachedFilesTable_DeleteButton__WPVD7","EditButton":"AttachedFilesTable_EditButton__fj8t7"};